'use client';

import { usePathname } from 'next/navigation';
import './styles/@theme';
import './styles/default.scss';
import { useState, useEffect } from 'react';
import { useStore } from '@/store/store';
import { classes } from '@/utils/classes/classes';
import SearchDrawer from '@/app/components/search-drawer/subcomponents/search-drawer-client/search-drawer.client';
import { SearchProvider } from '@/app/components/search-drawer/subcomponents/context';

type SearchDrawerContainerClientProps = {
    children: React.ReactNode;
};

const SearchDrawerContainerClient: React.FC<SearchDrawerContainerClientProps> = ({ children }) => {
    const search = useStore((s) => s.search);
    const closeSearch = useStore((s) => s.search.closeSearch);
    const isSearchRedesignOn = useStore((s) => s.search.isSearchRedesignVariant);
    const pathname = usePathname();

    useEffect(() => {
        closeSearch();
    }, [pathname, closeSearch]);

    const [topPosition, setTopPosition] = useState(0);

    useEffect(() => {
        if (!isSearchRedesignOn) {
            return;
        }

        const [header] = document.getElementsByTagName('header');
        if (!header) {
            return;
        }

        const [headerContent] = header.getElementsByClassName('header-content');
        const [headerFixed] = header.getElementsByClassName('header-fixed');

        let topValue = 0;

        if (document.body.scrollTop === 0) {
            topValue = header.clientHeight;
        } else if (document.body.scrollTop <= headerContent.clientHeight) {
            topValue = header.clientHeight;
        } else {
            topValue = headerFixed.clientHeight + document.body.scrollTop;
        }

        setTopPosition(topValue);
    }, [search.isSearchOpen, isSearchRedesignOn]);

    return (
        <div
            data-testid="container"
            className={classes('search-drawer-container', search.isSearchOpen && 'open')}
            style={{ top: topPosition }}>
            <button data-testid="overlay" className="overlay" onClick={search.toggleIsSearchOpen}></button>
            <SearchProvider>
                <SearchDrawer>{children}</SearchDrawer>
            </SearchProvider>
        </div>
    );
};

export default SearchDrawerContainerClient;
